"use strict";

angular.module("models").service("CustomerCommunicationsService", ["ApiService", function (ApiService) {
  var that = this;

  var params = {
    name: "customerCommunications",
    attributesForCache: ["name"],
    formatName: function formatName(element) {
      return element.name ? element.name : "???";
    },
    defaultOrder: { creationDate: -1 }
  };

  angular.extend(that, ApiService.getModelBis(params));
}]);